import { useQuery } from '@tanstack/react-query'
import { tasksApi } from '../../../api/tasks.api'

const FIELD_LABELS: Record<string, string> = {
  created: 'Erstellt',
  title: 'Titel',
  priority: 'Priorität',
  dueDate: 'Fälligkeitsdatum',
  progress: 'Fortschritt',
  status: 'Status',
  assignees: 'Verantwortliche',
  labels: 'Labels',
}

function formatValue(value: unknown): string {
  if (value === null || value === undefined) return '–'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

export function TaskHistoryList({ taskId }: { taskId: string }) {
  const historyQuery = useQuery({ queryKey: ['tasks', taskId, 'history'], queryFn: async () => (await tasksApi.getHistory(taskId)).data })

  if (!historyQuery.data || historyQuery.data.length === 0) {
    return <span style={{ color: 'var(--text-muted)', fontSize: 'var(--text-sm)' }}>Keine Historie vorhanden.</span>
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
      {historyQuery.data.map((entry) => (
        <div key={entry.id} style={{ fontSize: 'var(--text-sm)', display: 'flex', gap: 'var(--space-2)' }}>
          <span style={{ color: 'var(--text-muted)', fontSize: 'var(--text-xs)', whiteSpace: 'nowrap' }}>
            {new Date(entry.createdAt).toLocaleString('de-DE')}
          </span>
          <span>
            <strong>{FIELD_LABELS[entry.field] ?? entry.field}</strong>
            {entry.field !== 'created' ? (
              <>
                : {formatValue(entry.oldValue)} → {formatValue(entry.newValue)}
              </>
            ) : null}
          </span>
        </div>
      ))}
    </div>
  )
}
